import { Component, Input, OnInit } from '@angular/core';
import { PlaidService } from '../../../../../services/plaid.service';
import { LinkedBankAccount } from '../../../../../models/entities/linked-bank-account';
import { PaymentBankAccount } from '../../../../../models/entities/payment-bank-account';

// noinspection ES6ConvertVarToLetConst
declare var Plaid: any;

export interface PlaidSuccessMetaData
{
    institution: {
        name: string;
        institutionId: number;
    };
    account_id: string;
    account: {
        id: string;
        name: string;
        mask: string;
        type: string;
        subtype: string;
        verificationStatus: string;
    };
    accounts: {
        id: string;
        name: string;
        mask: string;
        type: string;
        subtype: string;
        verificationStatus: string;
    }[];
    linkSessionId: string;
}

export interface PlaidLinkResult
{
    success: boolean;
    publicToken?: string;
    metadata?: PlaidSuccessMetaData;
}

@Component({
    selector: 'lf-plaid-link',
    template: ``,
})
export class PlaidLinkComponent implements OnInit
{
    @Input() public userWorkflow: boolean = false;
    @Input() public institutionId: string = null;

    public plaidObject: any;

    constructor(private _plaidService: PlaidService) {
    }

    ngOnInit() {

    }

    public linkNewAccount(context: string, institutionId: string = null): Promise<PlaidLinkResult> {
        return new Promise<PlaidLinkResult>((success, reject) => {
            this._plaidService.getLinkToken(context, null, institutionId).subscribe(
                    (token) => {
                        const plaidConfig = {
                            onSuccess: (publicToken: any, metadata: any) => {
                                const successEvent: PlaidLinkResult = {
                                    success: true,
                                    publicToken: publicToken,
                                    metadata: metadata,
                                };
                                this.plaidObject.destroy();
                                success(successEvent);
                            },
                            onExit: (error: any, metadata: any) => {
                                const event = {
                                    error: error,
                                    metadata: metadata,
                                };
                                console.log('Your Plaid Link Session ID was ' + metadata.linkSessionId);
                                console.log('Please provide your Link Session ID to PayHOA Staff if requested.');
                                this.plaidObject.destroy();
                                if (error !== null) {
                                    // an error occurred in plaid
                                    reject(event);
                                } else {
                                    // The user exited the workflow
                                    success({success: false});
                                }
                            },
                            selectAccount: true,
                            token: token,
                        };

                        this.plaidObject = Plaid.create(plaidConfig);

                        if (institutionId !== null) {
                            this.plaidObject.open(institutionId);
                        } else {
                            this.plaidObject.open();
                        }
                    },
                    (err) => {
                        reject(err);
                    },
            );
        });
    }

    public repairLinkForUser(paymentBankAccount: PaymentBankAccount): Promise<PlaidLinkResult> {
        return new Promise<PlaidLinkResult>((success, reject) => {
            this._plaidService.getLinkToken('user', paymentBankAccount.id)
                    .subscribe(token => {
                        const plaidConfig = {
                            onSuccess: (publicToken: any, metadata: any) => {
                                const result: PlaidLinkResult = {
                                    success: true,
                                    publicToken: publicToken,
                                    metadata: metadata,
                                };
                                this.plaidObject.destroy();
                                success(result);
                            },
                            onExit: (error: any, metadata: any) => {
                                const event = {
                                    error: error,
                                    metadata: metadata,
                                };
                                this.plaidObject.destroy();
                                reject(event);
                            },
                            selectAccount: true,
                            token: token,
                        };

                        this.plaidObject = Plaid.create(plaidConfig);
                        this.plaidObject.open();
                    });
        });
    }

    public repairLinkForOrg(linkedBankAccount: LinkedBankAccount): Promise<PlaidLinkResult> {
        return new Promise<PlaidLinkResult>((success, reject) => {
            this._plaidService.getLinkToken('organization', linkedBankAccount.id, linkedBankAccount.plaidInstitutionId).subscribe(
                    (token) => {
                        const plaidConfig = {
                            onSuccess: (publicToken: any, metadata: any) => {
                                const successEvent: PlaidLinkResult = {
                                    success: true,
                                    publicToken: publicToken,
                                    metadata: metadata,
                                };
                                this.plaidObject.destroy();
                                success(successEvent);
                            },
                            onExit: (error: any, metadata: any) => {
                                const event = {
                                    error: error,
                                    metadata: metadata,
                                };
                                this.plaidObject.destroy();
                                reject(event);
                            },
                            selectAccount: true,
                            token: token,
                        };

                        this.plaidObject = Plaid.create(plaidConfig);
                        this.plaidObject.open();
                    },
            );
        });
    }
}
